// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-customers-js": function componentSrcPagesCustomersJs() {
    return import("./../../src/pages/customers.js"
    /* webpackChunkName: "component---src-pages-customers-js" */
    );
  },
  "component---src-pages-customers-staff-js": function componentSrcPagesCustomersStaffJs() {
    return import("./../../src/pages/customersStaff.js"
    /* webpackChunkName: "component---src-pages-customers-staff-js" */
    );
  },
  "component---src-pages-downloads-athletes-js": function componentSrcPagesDownloadsAthletesJs() {
    return import("./../../src/pages/downloads-athletes.js"
    /* webpackChunkName: "component---src-pages-downloads-athletes-js" */
    );
  },
  "component---src-pages-downloads-js": function componentSrcPagesDownloadsJs() {
    return import("./../../src/pages/downloads.js"
    /* webpackChunkName: "component---src-pages-downloads-js" */
    );
  },
  "component---src-pages-features-js": function componentSrcPagesFeaturesJs() {
    return import("./../../src/pages/features.js"
    /* webpackChunkName: "component---src-pages-features-js" */
    );
  },
  "component---src-pages-icehockey-js": function componentSrcPagesIcehockeyJs() {
    return import("./../../src/pages/icehockey.js"
    /* webpackChunkName: "component---src-pages-icehockey-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-legal-js": function componentSrcPagesLegalJs() {
    return import("./../../src/pages/legal.js"
    /* webpackChunkName: "component---src-pages-legal-js" */
    );
  },
  "component---src-pages-organizer-js": function componentSrcPagesOrganizerJs() {
    return import("./../../src/pages/organizer.js"
    /* webpackChunkName: "component---src-pages-organizer-js" */
    );
  },
  "component---src-pages-presskit-js": function componentSrcPagesPresskitJs() {
    return import("./../../src/pages/presskit.js"
    /* webpackChunkName: "component---src-pages-presskit-js" */
    );
  },
  "component---src-pages-pricing-team-sports-js": function componentSrcPagesPricingTeamSportsJs() {
    return import("./../../src/pages/pricingTeamSports.js"
    /* webpackChunkName: "component---src-pages-pricing-team-sports-js" */
    );
  },
  "component---src-pages-privacy-policy-js": function componentSrcPagesPrivacyPolicyJs() {
    return import("./../../src/pages/privacyPolicy.js"
    /* webpackChunkName: "component---src-pages-privacy-policy-js" */
    );
  },
  "component---src-pages-social-media-js": function componentSrcPagesSocialMediaJs() {
    return import("./../../src/pages/socialMedia.js"
    /* webpackChunkName: "component---src-pages-social-media-js" */
    );
  },
  "component---src-pages-sport-js": function componentSrcPagesSportJs() {
    return import("./../../src/pages/sport.js"
    /* webpackChunkName: "component---src-pages-sport-js" */
    );
  },
  "component---src-pages-success-js": function componentSrcPagesSuccessJs() {
    return import("./../../src/pages/success.js"
    /* webpackChunkName: "component---src-pages-success-js" */
    );
  },
  "component---src-pages-support-js": function componentSrcPagesSupportJs() {
    return import("./../../src/pages/support.js"
    /* webpackChunkName: "component---src-pages-support-js" */
    );
  },
  "component---src-pages-support-lesson-js": function componentSrcPagesSupportLessonJs() {
    return import("./../../src/pages/supportLesson.js"
    /* webpackChunkName: "component---src-pages-support-lesson-js" */
    );
  },
  "component---src-pages-testimonials-js": function componentSrcPagesTestimonialsJs() {
    return import("./../../src/pages/testimonials.js"
    /* webpackChunkName: "component---src-pages-testimonials-js" */
    );
  },
  "component---src-pages-watch-now-js": function componentSrcPagesWatchNowJs() {
    return import("./../../src/pages/watchNow.js"
    /* webpackChunkName: "component---src-pages-watch-now-js" */
    );
  },
  "component---src-templates-blog-js": function componentSrcTemplatesBlogJs() {
    return import("./../../src/templates/blog.js"
    /* webpackChunkName: "component---src-templates-blog-js" */
    );
  },
  "component---src-templates-post-js": function componentSrcTemplatesPostJs() {
    return import("./../../src/templates/post.js"
    /* webpackChunkName: "component---src-templates-post-js" */
    );
  }
};